import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

const COLLECTION_NAME = "swimSetLibrary";

const cleanSet = (set = {}) => ({
    reps: set.reps || 1,
    distance: set.distance || "",
    setType: set.setType || "",
    style: set.style || "",
    intensity: set.intensity || "",
    interval: set.interval || "",
    equipment: set.equipment || "",
    technicalFocus: set.technicalFocus || "",
    description: set.description || "",
});

const SwimSetLibraryService = {
    getAll: async (idTenant) => {
        if (!idTenant) return [];

        const q = query(
            collection(db, "tenants", idTenant, COLLECTION_NAME),
            orderBy("createdAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, source: "tenant", ...doc.data() }));
    },

    save: async ({ idTenant, authUser, name, category = "Personalizado", set }) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");
        if (!name?.trim()) throw new Error("Nome do set é obrigatório.");

        const payload = {
            name: name.trim(),
            category,
            set: cleanSet(set),
            createdAt: serverTimestamp(),
            createdBy: {
                uid: authUser?.uid || "system",
                name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema",
            },
        };

        const docRef = await addDoc(collection(db, "tenants", idTenant, COLLECTION_NAME), payload);
        return { id: docRef.id, source: "tenant", ...payload };
    },

    rename: async ({ idTenant, setId, name, category }) => {
        if (!idTenant || !setId) throw new Error("Tenant e Set IDs são obrigatórios.");
        if (!name?.trim()) throw new Error("Nome do set é obrigatório.");

        const payload = {
            name: name.trim(),
            category: category || "Personalizado",
            updatedAt: serverTimestamp(),
        };

        await updateDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, setId), payload);
        return { id: setId, source: "tenant", ...payload };
    },

    delete: async ({ idTenant, setId }) => {
        if (!idTenant || !setId) throw new Error("Tenant e Set IDs são obrigatórios.");
        await deleteDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, setId));
        return true;
    },
};

export default SwimSetLibraryService;
